"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = uninstallConfirmModalReducer;

var _immutable = _interopRequireDefault(require("immutable"));

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var _RequestStatusTypes = _interopRequireDefault(require("../constants/RequestStatusTypes"));

var defaultState = _immutable.default.Map({
  goodToUninstall: {},
  open: false,
  uninstallRequestError: null,
  uninstallRequestStatus: _RequestStatusTypes.default.UNINITIALIZED
});

function uninstallConfirmModalReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.SHOW_UNINSTALL_CONFIRM_MODAL:
      return state.merge({
        goodToUninstall: action.payload,
        open: true
      });

    case _ActionTypes.default.UNINSTALL_GOOD:
      if (action.error) {
        return state.merge({
          uninstallRequestError: action.payload,
          uninstallRequestStatus: _RequestStatusTypes.default.FAILED
        });
      }

      return state.set('uninstallRequestStatus', _RequestStatusTypes.default.PENDING);

    case _ActionTypes.default.DISMISSED_UNINSTALL_CONFIRM_MODAL:
    case _ActionTypes.default.PURCHASED_GOODS_RECEIVED:
      return defaultState;

    default:
      return state;
  }
}

module.exports = exports.default;